import Cookies from 'js-cookie'

const expireDay = 365
const pathName = ''

const TokenKey = 'passport'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: expireDay, path: pathName })
}

export function removeToken() {
  return Cookies.remove(TokenKey, { path: pathName })
}

const userKey = 'user'

export function getUserInfo() {
  return JSON.parse(Cookies.get(userKey) || null)
}

export function setUserInfo(val) {
  const data = {
    id: val.id,
    trueName: val.trueName,
    mobile: val.mobile,
    avatar: val.avatar
  }
  return Cookies.set(userKey, data, { expires: expireDay, path: pathName })
}

export function removeUserInfo() {
  return Cookies.remove(userKey, { path: pathName })
}


const roleKey = 'roles'

export function getRoles() {
  return JSON.parse(Cookies.get(roleKey) || null)
}

export function setRoles(roles) {
  return Cookies.set(roleKey, roles, { expires: expireDay, path: pathName })
}

export function removeRoles() {
  return Cookies.remove(roleKey, { path: pathName })
}
